module.exports = __webpack_public_path__ + "static/media/stop-long-icon.4fd5427e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/stop-long-icon.svg
// module id = 916
// module chunks = 0